import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import flashTokens from "@amzn/meridian-tokens/base/icon/flash";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import LogManager from "../../../utils/LogManager";

const PROMPT_BUTTONS = [
  { id: "catchMeUp", label: "Catch me up", icon: flashTokens },
  { id: "nameMentioned", label: "Was my name mentioned", icon: userTokens },
];

const AssistantOptions = ({ onOptionSelect, alias }) => {
  const handleClick = (btn) => {
    LogManager.metric(`Assistant_PromptButton_${btn.id}_Click`, 1, alias ? { alias } : {});
    onOptionSelect && onOptionSelect(btn.label);
  };

  return (
    <Column width="318px" spacing="none">
      <Text fontFamily="amazonEmber" type="h200" alignment="start">
        Just tune in? Here's the story so far.
      </Text>
      <Row height="16px" />
      {PROMPT_BUTTONS.map((btn) => (
        <Theme key={btn.id} tokens={{ boxBorderColorOutline: "#E2E6E8", buttonSpacingInsetHorizontalXlarge: 0, buttonSpacingInsetVerticalXlarge: 0, buttonHeightXlarge: 44 }}>
          <Column spacing="none">
            <Button type="icon" size="xlarge" onClick={() => handleClick(btn)}>
              <Box type="outline" width="318px" height="44px">
                <Column alignmentVertical="center" height="44px" spacingInset="0 300">
                  <Row spacing="300" alignmentVertical="center">
                    <Icon tokens={btn.icon} color="secondary" />
                    <Text fontFamily="amazonEmber" type="b200" color="secondary">{btn.label}</Text>
                  </Row>
                </Column>
              </Box>
            </Button>
            <Row height="8px" />
          </Column>
        </Theme>
      ))}
    </Column>
  );
};

export default AssistantOptions;
